module.exports = __webpack_public_path__ + "static/media/icon_wellness.9c849822.svg";